import {Component, inject} from '@angular/core';
import {GameService} from "../../../services/game.service";
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe} from "@angular/common";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {CharityPayoutsComponent} from "../charity-payouts.component";

@Component({
  selector: 'app-game-admin-charity-payouts',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe,
    ChooseYourGameComponent,
    ContainerComponent,
    CharityPayoutsComponent
  ],
  templateUrl: './game-admin-charity-payouts.component.html',
  styleUrl: './game-admin-charity-payouts.component.css'
})
export class GameAdminCharityPayoutsComponent {
  private gameService: GameService = inject(GameService);

  protected activeGame =  this.gameService.activeGame();
}
